export default {"src":"/_next/static/media/icon-external.61594ba3.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};